import React, { useContext, useState } from 'react';
import { NavLink, Route, Switch, Redirect } from 'react-router-dom';
import Page from '../../../components/Page';
import AccountSecurity from './AccountSecurity';
import AccountSettings from './AccountSettings';
import SystemViewers from './SystemViewers';
import PaymentSettings from './PaymentSettings';
import SystemInformation from './SystemInformation';
import ContractDetails from './ContractDetails';
import './Account.scss';
import RoundedButton from '../../../components/RoundedButton';
import AuthContext from '../../../contexts/AuthContext';

export default function AccountPage (props) {
    const [loading, setLoading] = useState(false);
    const { system } = useContext(AuthContext);

    return (
        <Page
            title="My Account"
            busy={loading}
            headerItem={(
                system.is_owner ? (
                    <div style={{ flexWrap: 'wrap', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 10 }}>
                        <RoundedButton
                            onClick={(e) => {
                                e.preventDefault();
                                window.open('https://srechelp.carbonsolutionsgroup.com/hc/en-us/requests/new?ticket_form_id=9545525917204', '_blank');
                            }}
                        >
                            Update Payment Address Request
                        </RoundedButton>
                        <RoundedButton
                            onClick={(e) => {
                                e.preventDefault();
                                window.open('https://srechelp.carbonsolutionsgroup.com/hc/en-us/requests/new?ticket_form_id=7264187751956', '_blank');
                            }}
                        >
                            Transfer of Ownership Request
                        </RoundedButton>
                    </div>
                ) : null
            )}
        >
            <div className='account'>
                <ul className='account--nav'>
                    <li>
                        <NavLink to="/account" exact>Account Settings</NavLink>
                    </li>
                    {system.is_owner ? (
                        <li>
                            <NavLink to="/account/payment-settings">Payment Settings</NavLink>
                        </li>
                    ) : null}
                    <li>
                        <NavLink to="/account/system-info" exact>System Information</NavLink>
                    </li>
                    <li>
                        <NavLink to="/account/contract-details" exact>Contract Details</NavLink>
                    </li>
                    {system.is_owner ? (
                        <li>
                            <NavLink to="/account/system-viewers" exact>Manage System Viewers</NavLink>
                        </li>
                    ) : null}
                </ul>
                <div className='account--content'>
                    <Switch>
                        <Route path="/account" render={() => <AccountSettings onLoad={() => setLoading(true)} onLoadEnd={() => setLoading(false)} />} exact={true} />
                        <Route path="/account/system-info" render={() => <SystemInformation onLoad={() => setLoading(true)} onLoadEnd={() => setLoading(false)} />} exact={true} />
                        <Route path="/account/contract-details" render={() => <ContractDetails onLoad={() => setLoading(true)} onLoadEnd={() => setLoading(false)} />} exact={true} />
                        <Route path="/account/security" render={() => <AccountSecurity onLoad={() => setLoading(true)} onLoadEnd={() => setLoading(false)} />} />
                        {system.is_owner ? (
                            <>
                                <Route path="/account/payment-settings" render={() => <PaymentSettings onLoad={() => setLoading(true)} onLoadEnd={() => setLoading(false)} />} />
                                <Route path="/account/system-viewers" render={() => <SystemViewers onLoad={() => setLoading(true)} onLoadEnd={() => setLoading(false)} />} />
                            </>
                        ) : null}
                        <Route path="/">
                            <Redirect to="/account" />
                        </Route>
                    </Switch>
                </div>
            </div>
        </Page>
    );
};